
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import StageBaseController from '../stage-base.controller';

export default class PensamentoController extends StageBaseController {
	constructor($log, $state, $timeout, $interval, Dialog, Session) {
		'ngInject';
		super($log, $state, $timeout, $interval, Dialog, Session, 2);
		this.Session = Session;
	}

	$onInit(){
		this.lodash_version = _.VERSION;
		this.startGame();
	}

	$onDestroy(){
		this.resetStage();
	}

	// onFinishStep1(){
		
	// }
}


// WEBPACK FOOTER //
// ./src/app/pages/pensamento/pensamento.controller.js